import { render } from "./XilemaSC.vue?vue&type=template&id=31721d0c&scoped=true"
import script from "./XilemaSC.vue?vue&type=script&lang=js"
export * from "./XilemaSC.vue?vue&type=script&lang=js"

import "./XilemaSC.vue?vue&type=style&index=0&id=31721d0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31721d0c"]])

export default __exports__